module.exports = "./dist/stdassets/cursors/digitizeCircle.cur";